import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters({
      currentSelectedOrg: 'Permissions/currentSelectedOrg',
    }),
  },
  watch: {
    currentSelectedOrg: {
      handler: function (newOrg, oldOrg) {
        if (oldOrg.id) {
          if (newOrg.id !== oldOrg.id) this.$router.push(`/organizations/${newOrg.id}`)
          else this.$router.push('/')
        }
      },
      deep: true,
    },
  },
}
